import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

// Privacy: Sentry gets only the visitor id (set in store/modules/auth.js), never names or e-mails.
const EMAIL = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi

function scrub (value, depth = 0) {
  if (typeof value === 'string') {
    return value.replace(EMAIL, '[email]')
  }
  if (!value || typeof value !== 'object' || depth > 8) {
    return value
  }
  Object.keys(value).forEach(key => { value[key] = scrub(value[key], depth + 1) })
  return value
}

Sentry.init({
  Vue,
  dsn: 'https://abe4ff3c025a4259809e13768fd4e5dd@o417521.ingest.sentry.io/5563876',
  autoSessionTracking: true,
  integrations: [
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.1,
  environment: process.env.NODE_ENV,

  sendDefaultPii: false,
  beforeSend (event) {
    // keep only the id of the user, then mask any e-mail address left in messages, breadcrumbs, URLs or extras
    event.user = event.user && event.user.id ? { id: event.user.id } : undefined
    return scrub(event)
  },
});
